import Common from "common/services/Common";
import { openLoader, closeLoader } from "data/screenLoader/actions";
import { errorMessages } from "common/constants/Messages";
import { setRedirectTabAction } from "data/landing/actions";
import { PATH_SEARCH_RESULTS, PATH_LOCK_SUMMARY } from "routes/constants";
import { DEBUG_BUYSIDE } from "common/constants/AppGlobals";
import Session, { JWT_TOKEN, USER_TYPE } from "services/Session";
import LoginService from "./LoginService";

const getLogin = ({ userName, password }) => async (dispatch) => {
  const { INVALID_USER, GENERAL_ERROR_MODAL } = errorMessages;
  dispatch(openLoader("Authenticating User"));
  let result = "";
  try {
    result = await LoginService.login(userName, password);
    if (result.token) {
      Session.set(JWT_TOKEN, result.token);
      Session.set(USER_TYPE, { userName, userType: "StandAlone" });
      await Common.setUserRoles();
      await Common.setClientRoles();
      if (DEBUG_BUYSIDE) {
        dispatch(setRedirectTabAction(PATH_LOCK_SUMMARY));
      }
      if (!DEBUG_BUYSIDE) {
        dispatch(setRedirectTabAction(PATH_SEARCH_RESULTS));
      }
    } else {
      result = new Error(INVALID_USER).message;
      dispatch(closeLoader());
    }
  } catch (e) {
    result = new Error(GENERAL_ERROR_MODAL).message;
    dispatch(closeLoader());
  }
  return result;
};

export default getLogin;
